import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  mutation DownvoteThreadAnswer(
    $courseId: String!
    $threadId: String!
    $answerId: String!
  ) {
    downvoteThreadAnswer(
      courseId: $courseId
      threadId: $threadId
      answerId: $answerId
      input: {}
    )
      @rest(
        type: "ThreadAnswer"
        path: "/courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}/downvote"
        method: "PUT"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
